import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface ListItemIconProps {
  iconName?: IconProp;
  iconSize?: SizeProp;
  iconClass?: string;
  fixedWidth?: boolean;
}

interface ListItemTextProps {
  text: string;
  textClass?: string;
}

interface ListItemProps extends ListItemIconProps, ListItemTextProps {
  itemClass?: string;
}

export const ListItem = ({
  itemClass,
  iconName,
  iconClass,
  iconSize,
  fixedWidth = true,
  text,
  textClass,
}: ListItemProps) => {
  return (
    <li className={itemClass}>
      {iconName ? (
        <FontAwesomeIcon
          className={iconClass}
          size={iconSize}
          fixedWidth={fixedWidth}
          icon={iconName}
        />
      ) : null}
      <span className={textClass}>{text}</span>
    </li>
  );
};
